import { URL_API } from "../constants/API";
import { UserBarrilitoI } from "../models/usersBarrilito";

export const UUID = () => {
    return  btoa(Math.random().toString()).substring(0, 10)
}

export const isNewRegister = (id:string) => id==='nuevo'

export const generateSlug = (str:string) => {
    return str
      .toLowerCase()
      .replace(/[^\w ]+/g,'')
      .replace(/ +/g,'-');
  }

export const urlApi = (api:string) =>{
    return `${URL_API}${api}`
}

export const UUIDATE = () => {
    let d = new Date().getTime();
    const uuid = "xxxxxxxx-xxxx-4xxx-yxxx".replace(/[xy]/g, c => {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
};

export const formatDate = (date: Date | string) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('es-ES', { 
        day: '2-digit', 
        month: '2-digit', 
        year: 'numeric' 
    });
}

export const formatDateHourMinute = (date: Date | string) => {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleString('es-ES', { 
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit', 
        minute: '2-digit', 
    });
}



export const getUserName = (usersBarrilito: UserBarrilitoI | undefined) => {
    if(!usersBarrilito || !usersBarrilito.nombre) return 'Sin usuario'
    return `${usersBarrilito.nombre} ${usersBarrilito.apellidoPaterno} ${usersBarrilito.apellidoMaterno}`
}